<div class="container-fluid p-3 bg-amber-50">

  <div class="bg-white rounded-md  border-2 border-blue-900 border-gray-300 px-4 py-2 sm:p-6 mb-4">
    <div class="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
      <div class="flex gap-3">

        <div class="flex-1">
          <h4 class="text-xl sm:text-2xl font-bold text-slate-800 mb-1">
            {{stepDetails?.name}}
          </h4>

          <h5 class="text-base sm:text-lg text-blue-600 font-semibold mb-3">
            [{{ payload?.proposal_name }}]
          </h5>


        </div>
        <div>

          <span class="inline-flex items-center px-3 py-1.5 border-2 rounded-full text-sm font-bold transition-all"
            [ngClass]="{
                            'bg-slate-100 text-slate-700 border border-slate-500': stepDetails?.step_status == 0,
                            'bg-emerald-100 text-emerald-700 border border-emerald-500': stepDetails?.step_status == 'approved',
                            'bg-amber-100 text-amber-700 border border-amber-500': stepDetails?.step_status == 'recommended',
                            'bg-blue-100 text-blue-700 border border-blue-500': stepDetails?.step_status == 'initiated'
                          }">
            <span class="w-2 h-2 rounded-full mr-2 animate-pulse" [ngClass]="{
                              'bg-slate-500': stepDetails?.step_status == 0,
                              'bg-emerald-500': stepDetails?.step_status == 'approved',
                              'bg-amber-500': stepDetails?.step_status == 'recommended',
                              'bg-blue-500': stepDetails?.step_status == 'initiated'
                            }"></span>
            {{ stepDetails?.step_status == 0 ? " PENDING" : (stepDetails?.step_status | uppercase) }}
          </span>
        </div>
      </div>

      <!-- Action Buttons -->
      <div class="flex flex-wrap items-center gap-2">
        <!-- <button class="bg-red-600 text-white px-3 py-2 rounded-xs text-sm me-2" (click)="generatePDF()">
          <i class="pi pi-file-pdf me-1"></i> PDF
        </button> -->
        <ng-container *ngIf="stepDetails?.can_edit">
          <button (click)="routeConfig.emit({isRouteConfig: true})"
            class="inline-flex items-center px-4 py-2.5 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 disabled:bg-slate-300 disabled:cursor-not-allowed transition-all duration-200 font-medium text-sm shadow-sm hover:shadow-md">
            <i class="pi pi-save mr-2"></i> Save/Forward/Route Config
          </button>
        </ng-container>
      </div>
    </div>
  </div>
  <hr class="my-3">



  <form  [formGroup]="challengeForm" class="proposal-form-container mb-4"
    *ngIf="false &&['makeII','makeI','makeIII'].includes(schemeType)">
    <div class="bg-amber-50 border-2 border-gray-300 mb-6 rounded transition-all duration-200 hover:shadow-md">
      <div (click)="expandedSections['mainExpansion'] = !expandedSections['mainExpansion']"
        class="flex items-center justify-between p-4 cursor-pointer bg-gray-100/90 text-gray-700 hover:bg-blue-950 hover:text-white transition-all duration-200">
        <h3 class="text-lg font-semibold flex items-center">
          <span class="w-8 h-8 rounded-lg bg-green-100 text-green-600 flex items-center justify-center mr-3 text-sm">
            <i class="pi pi-list"></i>
          </span>
          PSQR Data <span class="text-sm text-gray-500 bg-purple-100 text-purple-600 px-2 py-1 rounded ml-3">view</span>
        </h3>
        <i class="pi transition-transform duration-200"
          [ngClass]="expandedSections['mainExpansion'] ? 'pi-chevron-down' : 'pi-chevron-right'">
        </i>
      </div>
      <div *ngIf="expandedSections['mainExpansion']" class="p-6 space-y-4 border-t border-slate-100 animate-fade-in">
        <div class="form-container">
          <!-- Detailed Information Section -->
          <div class="bg-amber-50 border-2 border-gray-300 mb-6 rounded transition-all duration-200 hover:shadow-md">
            <div (click)="expandedSections['detailedInfo'] = !expandedSections['detailedInfo']"
              class="flex items-center justify-between p-4 cursor-pointer bg-gray-100/90 text-gray-700 hover:bg-blue-950 hover:text-white transition-all duration-200">
              <h3 class="text-lg font-semibold flex items-center">
                <span
                  class="w-8 h-8 rounded-lg bg-purple-100 text-purple-600 flex items-center justify-center mr-3 text-sm">
                  <i class="pi pi-list"></i>
                </span>
                Detailed Information
              </h3>
              <i class="pi transition-transform duration-200"
                [ngClass]="expandedSections['detailedInfo'] ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
            </div>
            <div *ngIf="expandedSections['detailedInfo']"
              class="p-6 space-y-4 border-t border-slate-100 animate-fade-in">
              <div class="editor-field" [class.readonly-editor]="isEditorDisabled">
                <p class="bg-blue-500 p-2  text-white font-medium">Essential Parameters</p>
                <editor [init]="previousInit" [formControlName]="'essential_parameter'" [disabled]="false"></editor>
              </div>
              <div class="editor-field" [class.readonly-editor]="isEditorDisabled">
                <p class="bg-blue-500 p-2  text-white font-medium">Desirable Parameters</p>
                <editor [init]="previousInit" [formControlName]="'desirable_parameter'" [disabled]="true"></editor>
              </div>
              <div class="editor-field" [class.readonly-editor]="isEditorDisabled">
                <p class="bg-blue-500 p-2  text-white font-medium">Functional Requirements</p>
                <editor [init]="previousInit" [formControlName]="'functional_req'" [disabled]="true"></editor>
              </div>
              <div class="editor-field" [class.readonly-editor]="isEditorDisabled">
                <p class="bg-blue-500 p-2  text-white font-medium">Performance Requirements</p>
                <editor [init]="previousInit" [formControlName]="'performance_req'" [disabled]="true"></editor>
              </div>
              <div class="editor-field" [class.readonly-editor]="isEditorDisabled">
                <p class="bg-blue-500 p-2  text-white font-medium">Technical Requirements</p>
                <editor [init]="previousInit" [formControlName]="'technical_req'" [disabled]="true"></editor>
              </div>
              <div class="editor-field" [class.readonly-editor]="isEditorDisabled">
                <p class="bg-blue-500 p-2  text-white font-medium">Operational Requirements</p>
                <editor [init]="previousInit" [formControlName]="'operational_req'" [disabled]="true"></editor>
              </div>
            </div>
          </div>

          <!-- Additional Information Section -->
          <div class="bg-amber-50 border-2 border-gray-300 mb-6 rounded transition-all duration-200 hover:shadow-md">
            <div (click)="expandedSections['additionalInfo'] = !expandedSections['additionalInfo']"
              class="flex items-center justify-between p-4 cursor-pointer bg-gray-100/90 text-gray-700 hover:bg-blue-950 hover:text-white transition-all duration-200">
              <h3 class="text-lg font-semibold flex items-center">
                <span
                  class="w-8 h-8 rounded-lg bg-purple-100 text-purple-600 flex items-center justify-center mr-3 text-sm">
                  <i class="pi pi-file"></i>
                </span>
                Additional Information
              </h3>
              <i class="pi transition-transform duration-200"
                [ngClass]="expandedSections['additionalInfo'] ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
            </div>
            <div class="p-6 space-y-4 border-t border-slate-100 animate-fade-in"
              *ngIf="expandedSections['additionalInfo']">
              <div class="editor-field" [class.readonly-editor]="isEditorDisabled">
                <p class="bg-blue-500 p-2  text-white font-medium">Logistical Requirements</p>
                <editor [init]="previousInit" [formControlName]="'logistical_req'" [disabled]="true"></editor>
              </div>
              <div class="editor-field" [class.readonly-editor]="isEditorDisabled">
                <p class="bg-blue-500 p-2  text-white font-medium">Cost Requirements</p>
                <editor [init]="previousInit" [formControlName]="'cost_req'" [disabled]="true"></editor>
              </div>
              <div class="editor-field" [class.readonly-editor]="isEditorDisabled">
                <p class="bg-blue-500 p-2  text-white font-medium">Timeline Requirements</p>
                <editor [init]="previousInit" [formControlName]="'timeline_req'" [disabled]="true"></editor>
              </div>
              <div class="editor-field" [class.readonly-editor]="isEditorDisabled">
                <p class="bg-blue-500 p-2  text-white font-medium">Additional Requirements</p>
                <editor [init]="previousInit" [formControlName]="'additonal_req'" [disabled]="true"></editor>
              </div>
            </div>
          </div>
          <!-- Document Upload Section -->
          <div class="bg-amber-50 border-2 border-gray-300 mb-6 rounded transition-all duration-200 hover:shadow-md">
            <div (click)="expandedSections['uploads'] = !expandedSections['uploads']"
              class="flex items-center justify-between p-4 cursor-pointer bg-gray-100/90 text-gray-700 hover:bg-blue-950 hover:text-white transition-all duration-200">
              <h3 class="text-lg font-semibold flex items-center">
                <span
                  class="w-8 h-8 rounded-lg bg-purple-100 text-purple-600 flex items-center justify-center mr-3 text-sm">
                  <i class="pi pi-upload"></i>
                </span>
                Document Uploads
              </h3>
              <i class="pi transition-transform duration-200"
                [ngClass]="expandedSections['uploads'] ? 'pi-chevron-down' : 'pi-chevron-right'">
              </i>
            </div>
            <div *ngIf="expandedSections['uploads']" class="p-6 space-y-4 border-t border-slate-100 animate-fade-in">
              <app-upload-document [isEditable]="false" [proposal_step]="challengeForm.get('proposal_step')?.value">
              </app-upload-document>
            </div>
          </div>
        </div>
      </div>
    </div>

  </form>
  <form [formGroup]="challengeForm" class="proposal-form-container mb-4" *ngIf="['idex'].includes(schemeType)">
    <div class="bg-amber-50 border-2 border-gray-300 mb-6 rounded transition-all duration-200 hover:shadow-md">
      <div (click)="expandedSections['mainExpansion'] = !expandedSections['mainExpansion']"
        class="flex items-center justify-between p-2 cursor-pointer bg-gray-100/90 text-gray-700 hover:bg-blue-950 hover:text-white transition-all duration-200">
        <h3 class="text-lg font-semibold flex items-center">
          <span class="w-8 h-8 rounded-lg bg-green-100 text-green-600 flex items-center justify-center mr-3 text-sm">
            <i class="pi pi-list"></i>
          </span>
          Uploaded PSQR <span
            class="text-sm text-gray-500 bg-purple-100 text-purple-600 px-2 py-1 rounded ml-3">view</span>
        </h3>
        <i class="pi transition-transform duration-200"
          [ngClass]="expandedSections['mainExpansion'] ? 'pi-chevron-down' : 'pi-chevron-right'">
        </i>
      </div>
      <div *ngIf="expandedSections['mainExpansion']" class="p-1  border-t border-slate-100 animate-fade-in">
        <app-upload-document [isEditable]="false" [proposal_step]="ms_03Id"></app-upload-document>
      </div>
    </div>

  </form>

  <!-- <div class="row mb-4">
    <app-upload-document [isEditable]="stepDetails?.can_edit"></app-upload-document>

  </div> -->


  <form [formGroup]="commentForm">

    <div class="editor-field mt-4">
      <p class="bg-blue-500 p-2 text-white font-medium">SQR Content</p>
      <editor [init]="sqrEditorInit" [formControlName]="'introduction'" [disabled]="true"></editor>
    </div>
<br>
    <div class="editor-field">
      <p class="bg-blue-500 p-2  text-white font-medium">Justification</p>
      <editor [init]="previousInit" [formControlName]="'justification'" [disabled]="isEditorDisabled"></editor>
    </div>

  </form>
  <!-- Document Upload Section -->
  <div class="row mt-4">
    <div class="col-12">
      <div class="card shadow-sm mb-4">
        <div class="card-header bg-light">
          <h5 class="mb-0">Document Uploads</h5>
        </div>
        <div class="card-body">
          <app-upload-document [title]="(stepDetails?.name || 'PSQR to SQR') + ' Document'"
            [isEditable]="stepDetails?.can_edit">
          </app-upload-document>
        </div>
      </div>
    </div>
  </div>

</div>